module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ceB8U"))).then(() => module.bundle.root('ljYL6'));